import React from 'react';
import { ScheduleIcon } from '../../Icons';
import { Nullable, SearchItemViewModel, SearchMeta } from '../types';
import { convertToBillingUrl } from '../../../nav/utils/getBillingBaseUrl';

const chipState = {
  Pending: 'primary',
  Processing: 'primary',
  Completed: 'success',
  Posted: 'success',
  PostInProgress: 'primary',
  Error: 'error',
  Canceled: 'error',
  CancelInProgress: 'warning',
  RemoveInProgress: 'warning',
  Paused: 'warning',
};

function renderItem(billRun, t): Nullable<SearchItemViewModel> {
  return {
    title: billRun['BillRunNumber'],
    descriptionFields: [
      {
        type: 'Text',
        value: billRun['Account.Name'],
        title: billRun['Account.Name'],
      },
      {
        type: 'Text',
        value: billRun['Account.AccountNumber'],
        title: billRun['Account.AccountNumber'],
      },
      {
        type: 'Date',
        value: billRun['InvoiceDate'],
        title: t('BillRun.InvoiceDate'),
      },
    ],
    chipField: {
      state: chipState[billRun['Status']],
      label: t(`BillRun.Status.${billRun['Status']}`),
    },
    href: convertToBillingUrl(
      `/apps/NewBillingRun.do?method=view&id=${billRun.Id}`,
    ),
  };
}

export const BillRun: SearchMeta = {
  objectType: 'BillRun',
  objectLabelI18n: 'BillRun.TabLabel',
  tabIcon: <ScheduleIcon />,
  needsPermission: false,
  listPageUrl: convertToBillingUrl('/apps/NewBillingRun.do'),
  hasAdvancedSearch: true,
  renderItem,
};
